import { render, staticRenderFns } from "./DetailsRetail.vue?vue&type=template&id=31d2b064"
import script from "./DetailsRetail.vue?vue&type=script&lang=js"
export * from "./DetailsRetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports